import Vue from 'vue'

const USER_TO_ACCOUNT = {
	CREATE: (accountId) => {
		return Vue.$api.post('/user-to-accounts', { accountId })
	},
}

export default USER_TO_ACCOUNT
